"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultConfig = void 0;
const react_1 = __importDefault(require("react"));
const select_input_1 = __importDefault(require("../select-input"));
const TypeaheadInput = (props) => (react_1.default.createElement(select_input_1.default, Object.assign({ useTypeahead: true, mode: "typeahead" }, props)));
exports.default = TypeaheadInput;
exports.defaultConfig = {};
//# sourceMappingURL=index.js.map